import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { TextFieldInputContainerStyled as Container, TextFieldInputInputStyled as Input, SSITextH2Styled as Label } from '../../../styles';
const TextInputField = (props) => {
    const { initialValue, label, placeholder, maxLength, onChangeValue, style } = props;
    const [value, setValue] = React.useState(initialValue);
    const [isFocused, setIsFocused] = useState(false);
    const onChange = async (event) => {
        setValue(event.target.value);
        await onChangeValue?.(event.target.value);
    };
    const onFocus = () => {
        setIsFocused(true);
    };
    const onBlur = () => {
        setIsFocused(false);
    };
    return (_jsxs(Container, { style: { ...style }, children: [label && _jsx(Label, { children: label }), _jsx(Input, { onChange: onChange, value: value, placeholder: isFocused ? '' : placeholder, type: 'text', onFocus: onFocus, onBlur: onBlur, maxLength: maxLength })] }));
};
export default TextInputField;
